class ModalsClusters {
    constructor() {
        this.addListeners()
    }



    addListeners() {

        window.onload = () => {
            this.colleges()
            this.maps()
            this.hideArrows()
            this.mapModal()
        }

    }

    addModalListeners(modal) {
        const close = document.getElementById('clusterCloseButton')

        const modalContent = modal.querySelector('.cluster-content');
        

        close.addEventListener('click', () => {
            modal.classList.remove('cluster-overlay--active')
            modalContent.style.marginTop = '100px';
        })

        window.addEventListener('click', (e) => {
            if (e.target.id == 'clusterModal') {
                modal.classList.remove('cluster-overlay--active')
                modalContent.style.marginTop = '100px';
            }
        })

    }

    colleges() {

        const modal = document.getElementById('clusterModal')

        if (modal) {
            
            const proLink = document.querySelectorAll('.pro-list-toggle')
            this.addModalListeners(modal)
            proLink.forEach(link => {
                link.addEventListener('click', (e) => {                    
                    modal.querySelector('#map').style.display = 'none'
                    modal.classList.add('cluster-overlay--active')
                    const collegelist = link.getAttribute('data-bs-collegelist')
                    modal.querySelector('#collegesUl').innerHTML = collegelist                    
                    const modalContent = modal.querySelector('.cluster-content');
                    const diff = (window.innerHeight - modalContent.clientHeight) / 2

                    if (diff > 100 ) {
                        modalContent.style.marginTop = diff + 'px';
                    } else {
                        modalContent.style.marginTop = '100px';
                    }

                })
            })
        }

    }

    maps() {

        const modal = document.getElementById('clusterModal')

        if (modal) {
            const mapLink = document.querySelectorAll('.pro-map-toggle')
            this.addModalListeners(modal)

            ymaps.ready( () => {

                const myMap = new ymaps.Map("map", {
                    center: [55.73, 37.75],
                    zoom: 9
                });
    
                            
                const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'
    
                const defaultIconOptions = {
                    iconLayout: 'default#image', // Use custom image as icon
                    iconImageHref: iconUrl,
                    iconImageSize: [30, 30], // Size of the icon
                    iconImageOffset: [-15, -30] // Position of the icon (offset)
                };
                let yellowCollection = new ymaps.GeoObjectCollection();

                    mapLink.forEach(link => {
                        link.addEventListener('click', (e) => {
                            modal.querySelector('#collegesUl').innerHTML = ''                         
                            modal.querySelector('#map').style.display = 'block'
                            modal.classList.add('cluster-overlay--active')
                            const yellowCoords = JSON.parse(link.getAttribute('data-bs-coords'))
                            const names = JSON.parse(link.getAttribute('data-bs-names'))
                            const links = JSON.parse(link.getAttribute('data-bs-links'))

                            yellowCollection.removeAll();
                                    
                            for (var i = 0, l = yellowCoords.length; i < l; i++) {

                                let placemark = new ymaps.Placemark(yellowCoords[i], {
                                    balloonContent: "<a href='" + links[i] + "'>" + names[i] + "</a>"
                                }, defaultIconOptions);
                               
                                yellowCollection.add(placemark);
                            }

                            myMap.geoObjects.add(yellowCollection);
        
                        })
                    })
            });



        }

    }

    hideArrows() {
        const lists = document.querySelectorAll('.professions-college')

        if (lists) {

            lists.forEach(list => {
                const arrow = list.querySelector('.professions-hide-arrow')
                const header = list.querySelector('.cluster__list-header')

                header.addEventListener('click', (e) => {
                    arrow.classList.toggle('professions-hide-arrow--up')
                    list.classList.toggle('professions-college--hidden')
                })
            })
        }

    }

    mapModal() {
        var modal = document.getElementById("seeOnMap");
        var btn = document.getElementById("seeOnMapBtn");
        var span = document.getElementsByClassName("close")[0];

        if (btn && span && modal) {

            
            btn.onclick = function() {
                modal.style.display = "block";
            }

            span.onclick = function() {
                modal.style.display = "none";
            }

            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        }

    }

}


export default ModalsClusters




